import { convertToLowerCase } from "utilities/dataFormatting/text"

const apiProtocol = 'https'
const apiOrigin = 'api.monadlead.com'
const apiPath = 'api'
export const currentPersistedModuleVersion = 1;

const getFlagUrl = (code = '', size = 24) =>
  `${config.storageUrl}country/flags/${size}x${size}/${code ? convertToLowerCase(code) : ''}.png`


const config = {
  project: 'MonadLead',
  apiUrl: `${apiProtocol}://${apiOrigin}/${apiPath}/`,
  storageUrl: `${apiProtocol}://${apiOrigin}/storage/`,
  resourcesUrl: {
    countryFlag: {
      '16': (code) => getFlagUrl(code, 16),
      '24': (code) => getFlagUrl(code),
      '32': (code) => getFlagUrl(code, 32),
      '48': (code) => getFlagUrl(code, 48),
      '64': (code) => getFlagUrl(code, 64),
      '128': (code) => getFlagUrl(code, 128)
    }
  },
  externalLinks: {
    telegramChannel: 'https://t.me/monadleadnews',
  },
}
export { config }
export default config